import { Component, OnInit, HostListener} from '@angular/core';
import { AuthService } from './core/auth.service';
import { ConfigService } from './config.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'ri-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  lastAction: Date;
  interval;
  showMainFooter = true;
  constructor(
    private authService: AuthService, private router: Router
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url === '/' ||  val.url === '/login' || val.url === '/loginReset') {
          this.showMainFooter = false;
        } else if (val.url.includes('mobile')) {
          this.showMainFooter = false;
        } else {
          this.showMainFooter = true;
        }
      }
    });
  }

  // PO-5573 - logout after X minutes of inactivity
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.lastAction = new Date();
  }
  @HostListener('click', ['$event.target'])
  handleMouseClick(btn) {
    this.lastAction = new Date();
  }
  @HostListener('mousewheel', ['$event'])
  handleMouseWheel(event: MouseEvent) {
    this.lastAction = new Date();
  }

  ngOnInit() {
    this.authService.checkTokenAndSetUser();

    // PO-5573 - logout after X minutes of inactivity
    if (ConfigService.app.checkIdleTimeout) {

      this.lastAction = new Date();

      this.interval = setInterval(() => {
        if ( this.authService.isAccesTokenValid() ) { this.authService.checkForInactivity(this.lastAction); };
      }, 1000 * 60);

    }

  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts